import { render } from "./MarketSelection.vue?vue&type=template&id=243f6c9e&scoped=true"
import script from "./MarketSelection.vue?vue&type=script&lang=js"
export * from "./MarketSelection.vue?vue&type=script&lang=js"

import "./MarketSelection.vue?vue&type=style&index=0&id=243f6c9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243f6c9e"],['__file',"src/components/pattern/MarketSelection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "243f6c9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('243f6c9e', __exports__)) {
    api.reload('243f6c9e', __exports__)
  }
  
  module.hot.accept("./MarketSelection.vue?vue&type=template&id=243f6c9e&scoped=true", () => {
    api.rerender('243f6c9e', render)
  })

}


export default __exports__